export default "__VITE_ASSET__DtcMr78i__"